import { createTheme } from '@mui/material/styles';

export const createDashboardTheme = (isDark: boolean) =>
    createTheme({
        palette: {
            mode: isDark ? 'dark' : 'light',
            primary: {
                main: '#704dff'
            },

            text: {
                primary: isDark ? '#ffffff' : '#242424'
            }
        },
        typography: {
            fontFamily: 'Red Hat Text'
        }
    });
